import React from 'react'
import ReactDOM from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import './index.css'
import { AuthProvider, TAuthConfig } from 'react-oauth2-code-pkce'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import * as Sentry from '@sentry/react'
import './util/scope'
import { PROD } from './config/stage'
import { logMessage } from './util/Logging'
import { initOtel } from './otel'
import { mainRoutes, signinRoutes } from './routes'

const stage = import.meta.env.VITE_STAGE
const dsn = 'https://8dc821e5d3594e9c4eaabfe634b1dcf1@o232550.ingest.us.sentry.io/4508138519134208'

const logToSentry = !!import.meta.env.VITE_CI

initOtel()

Sentry.init({
  dsn: logToSentry ? dsn : '',
  integrations: [],
  environment: stage,
})

const authServiceStagePrefix = stage === PROD ? '' : 'test-'
const authServiceHost = `${authServiceStagePrefix}auth.eidu.com`

const authConfig: TAuthConfig = {
  clientId: 'eidu-console',
  authorizationEndpoint: `https://${authServiceHost}/realms/eidu/protocol/openid-connect/auth`,
  tokenEndpoint: `https://${authServiceHost}/realms/eidu/protocol/openid-connect/token`,
  redirectUri: window.location.origin + window.location.pathname,
  logoutEndpoint: `https://${authServiceHost}/realms/eidu/protocol/openid-connect/logout`,
  scope: 'openid profile',
  storage: 'session',
  preLogin: () => logMessage('preLogin', 'debug', 'AuthDebug'),
  postLogin: () => logMessage('postLogin', 'debug', 'AuthDebug'),
}

const signinRouter = createBrowserRouter(signinRoutes)
const mainRouter = createBrowserRouter(mainRoutes)

const isSignInPath = window.location.pathname === '/signin'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 0,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {isSignInPath ? (
      <RouterProvider router={signinRouter} />
    ) : (
      <AuthProvider authConfig={authConfig}>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={mainRouter} />
        </QueryClientProvider>
      </AuthProvider>
    )}
  </React.StrictMode>
)
